import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import {
	appCreateMembership,
	appDeleteMembership,
	appGetSansthaById,
	appUpdateMembership,
	appUpdateSanstha,
} from '../../store/sanstha'
import swal from 'sweetalert'
import { toast } from 'react-toastify'

function MembershipPaymentdetailsTab({ sansthaDetails }) {
	const dispatch = useDispatch()
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editSansthaId, setEditSansthaId] = useState(null)

	const Formik = useFormik({
		initialValues: {
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
			// qr_code: "",
			upi_id: sansthaDetails?.upi_id || '',
			account_name: sansthaDetails?.account_name || '',
			account_number: sansthaDetails?.account_number || '',
			bank_name: sansthaDetails?.bank_name || '',
			branch_name: sansthaDetails?.branch_name || '',
			ifsc_code: sansthaDetails?.ifsc_code || '',
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			membershipType: Yup.string().required('Select duration'),
			upi_id: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string()
					.required('UPI ID is required')
					.matches(/^[\w.-]+@[\w.-]+$/, 'Enter a valid UPI ID'),
				otherwise: Yup.string().notRequired(),
			}),
			account_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Account name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			account_number: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string()
					.required('Account number is required')
					.matches(/^[0-9]+$/, 'Enter a valid account number'),
				otherwise: Yup.string().notRequired(),
			}),
			bank_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Bank name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			branch_name: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string().required('Branch name is required'),
				otherwise: Yup.string().notRequired(),
			}),
			ifsc_code: Yup.string().when([], {
				is: () => !showModal,
				then: Yup.string()
					.required('IFSC code is required')
					.matches(/^[A-Z]{4}0[A-Z0-9]{6}$/i, 'Enter a valid IFSC code'),
				otherwise: Yup.string().notRequired(),
			}),
			honoraryReason: Yup.string().when('membershipType', {
				is: val =>
					val === 'Free( Honorary) with voting right' ||
					val === 'Family member ( free and without voting right)',
				then: Yup.string().required('Honorary reason is required'),
				otherwise: Yup.string().notRequired(),
			}),

			membershipfee: Yup.number().when('membershipType', {
				is: val =>
					val !== 'Free( Honorary) with voting right' &&
					val !== 'Family member ( free and without voting right)',
				then: Yup.number().required('Membership fee is required'),
				otherwise: Yup.number().notRequired(),
			}),
		}),

		onSubmit: async values => {
			const selectedType = values.membershipType

			const existingTypes = sansthaDetails?.membership?.map(m => m.membershipType) || []
			const isDuplicate = existingTypes.includes(selectedType)

			if (!editMode && isDuplicate) {
				toast.error(`${selectedType} membership already exists.`)
				return
			}
			const isHonorary =
				selectedType === 'Free( Honorary) with voting right' ||
				selectedType === 'Family member ( free and without voting right)'

			const membershipPayload = {
				membershipType: selectedType,
				membershipfee: values.membershipfee,
				...(isHonorary
					? { honoraryReason: values.honoraryReason }
					: { membershipfee: values.membershipfee }),
			}
			const basePayload = {
				sansthaId: sansthaDetails?._id,
				membership: membershipPayload,
			}
			try {
				if (editMode && editSansthaId) {
					const payload = {
						...basePayload,
						membershipId: editSansthaId,
					}

					dispatch(appUpdateMembership(payload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				} else {
					dispatch(appCreateMembership(basePayload)).then(() => {
						dispatch(appGetSansthaById(sansthaDetails?._id))
					})
				}

				setShowModal(false)
				setEditMode(false)
				setEditSansthaId(null)
				Formik.resetForm()
			} catch (error) {
				toast.error('Something went wrong. Please try again.')
			}
		},
	})

	const handleEditMembership = sanstha => {
		setEditMode(true)
		setEditSansthaId(sanstha?._id || null)

		Formik.setValues({
			membershipType: sanstha?.membershipType || '',
			membershipfee: sanstha?.membershipfee || '',
			honoraryReason: sanstha.honoraryReason || '',
			upi_id: Formik.values.upi_id || '',
			account_name: Formik.values.account_name || '',
			account_number: Formik.values.account_number || '',
			bank_name: Formik.values.bank_name || '',
			branch_name: Formik.values.branch_name || '',
			ifsc_code: Formik.values.ifsc_code || '',
		})

		setShowModal(true)
	}

	const handleDeleteMembership = membershipId => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Membership?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(
					appDeleteMembership({
						sansthaId: sansthaDetails?._id,
						membershipId,
					}),
				).then(() => {
					dispatch(appGetSansthaById(sansthaDetails?._id))
				})
			}
		})
	}

	const handleAddNewMembership = () => {
		setEditMode(false)
		setEditSansthaId(null)
		Formik.resetForm()
		Formik.setValues({
			membershipType: '',
			membershipfee: '',
			honoraryReason: '',
			upi_id: Formik.values.upi_id || '',
			account_name: Formik.values.account_name || '',
			account_number: Formik.values.account_number || '',
			bank_name: Formik.values.bank_name || '',
			branch_name: Formik.values.branch_name || '',
			ifsc_code: Formik.values.ifsc_code || '',
		})
		setShowModal(true)
	}

	const paymentFields = [
		{ name: 'upi_id', label: 'UPI ID *', placeholder: 'example@bank' },
		{ name: 'account_name', label: 'Account Name *', placeholder: 'Enter account holder name' },
		{ name: 'account_number', label: 'Account Number *', placeholder: 'Enter account number' },
		{ name: 'bank_name', label: 'Bank Name *', placeholder: 'Enter bank name' },
		{ name: 'branch_name', label: 'Branch Name *', placeholder: 'Enter branch name' },
		{ name: 'ifsc_code', label: 'IFSC Code *', placeholder: 'ABCD0123456' },
	]

	const handlesavepaymentdetails = () => {
		const payload = {
			id: sansthaDetails?._id,
			upi_id: Formik.values.upi_id,
			bank_name: Formik.values.bank_name,
			branch_name: Formik.values.branch_name,
			account_name: Formik.values.account_name,
			account_number: Formik.values.account_number,
			ifsc_code: Formik.values.ifsc_code,
		}

		dispatch(appUpdateSanstha(payload))
	}

	return (
		<div>
			<div className="mb-3 d-flex justify-content-end">
				<button className="btn btn-primary" onClick={handleAddNewMembership}>
					<i className="far fa-plus"></i> Add New Membership
				</button>
			</div>
			<div
				className="mb-3"
				style={{
					border: '1px solid #d9e0e7',
					borderRadius: '8px',
					padding: '16px 14px 8px',
					backgroundColor: '#fff',
				}}
			>
				<div className="mb-3">
					<h5 className="mb-1" style={{ fontWeight: 500 }}>
						Payment Details
					</h5>
					<p className="mb-0 text-muted">
						Fill all fields and save the bank details used for membership payments.
					</p>
				</div>
				<div className="row">
					{paymentFields.map(field => (
						<div className="col-xl-2 col-lg-4 col-md-6 mb-3" key={field.name}>
							<div className="form-group mb-0">
								<label>{field.label}</label>
								<input
									type="text"
									className="form-control"
									name={field.name}
									placeholder={field.placeholder}
									value={Formik.values[field.name]}
									onChange={Formik.handleChange}
									onBlur={Formik.handleBlur}
									style={{ height: '40px' }}
								/>
								{Formik.touched[field.name] && Formik.errors[field.name] && (
									<div className="text-danger" style={{ fontSize: '12px' }}>
										{Formik.errors[field.name]}
									</div>
								)}
							</div>
						</div>
					))}
					<div className="col-12 d-flex justify-content-end mb-2">
						<button
							className="btn btn-labeled btn-primary"
							onClick={async () => {
								const errors = await Formik.validateForm()
								const paymentTouched = paymentFields.reduce(
									(touched, field) => ({ ...touched, [field.name]: true }),
									{},
								)
								Formik.setTouched(paymentTouched)
								const hasPaymentError = paymentFields.some(field => errors[field.name])
								if (!hasPaymentError) {
									handlesavepaymentdetails()
								}
							}}
							type="button"
							style={{ minWidth: '220px', height: '42px', whiteSpace: 'nowrap' }}
						>
							<span className="btn-label">
								<i className="fa fa-check"></i>
							</span>
							Save Payment Details
						</button>
					</div>
				</div>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>Membership Duration </th>
							<th>Membership Fee/Reason</th>

							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{sansthaDetails?.membership && sansthaDetails.membership.length > 0 ? (
							sansthaDetails.membership.map((membership, index) => (
								<tr key={membership._id || index}>
									<td>{index + 1}</td>
									<td>{membership.membershipType}</td>
									<td>
										{membership.membershipType === 'Free( Honorary) with voting right' ||
										membership.membershipType === 'Family member ( free and without voting right)'
											? membership.honoraryReason
											: membership.membershipfee}
									</td>
									<td>
										<button
											className="btn btn-sm btn-primary mr-2"
											title="Edit"
											onClick={() => handleEditMembership(membership)}
										>
											<i className="far fa-edit"></i>
										</button>
										<button
											className="btn btn-sm btn-danger"
											title="Delete"
											onClick={() => handleDeleteMembership(membership?._id)}
										>
											<i className="far fa-trash-alt"></i>
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="4" className="text-center">
									No membership data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg" style={{ marginTop: '200px' }}>
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{editMode
										? 'Edit Membership Type and Payment Details'
										: 'Create New Membership Type and Payment Details'}
								</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditSansthaId(null)
										Formik.resetForm()
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={Formik.handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Membership Duration *</label>
												<select
													className="form-control"
													name="membershipType"
													value={Formik.values.membershipType}
													onChange={Formik.handleChange}
													onBlur={Formik.handleBlur}
												>
													<option value="">Select Duration</option>
													<option value="Monthly">Monthly</option>
													<option value="Yearly">Yearly</option>
													<option value="Lifetime">Lifetime</option>
													<option value="Free( Honorary) with voting right">
														Free( Honorary) with voting right
													</option>
													<option value="Family member ( free and without voting right)">
														Family member ( free and without voting right)
													</option>
												</select>
												{Formik.touched.membershipType && Formik.errors.membershipType ? (
													<div className="text-danger">{Formik.errors.membershipType}</div>
												) : null}
											</div>
										</div>

										<div className="col-md-6">
											<div className="form-group">
												{Formik.values.membershipType === 'Free( Honorary) with voting right' ||
												Formik.values.membershipType ===
													'Family member ( free and without voting right)' ? (
													<>
														<label> Reason *</label>
														<input
															type="text"
															className="form-control"
															name="honoraryReason"
															value={Formik.values.honoraryReason || ''}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.honoraryReason && Formik.errors.honoraryReason ? (
															<div className="text-danger">{Formik.errors.honoraryReason}</div>
														) : null}
													</>
												) : (
													<>
														<label>Membership Fee *</label>
														<input
															type="number"
															className="form-control"
															name="membershipfee"
															value={Formik.values.membershipfee}
															onChange={Formik.handleChange}
															onBlur={Formik.handleBlur}
														/>
														{Formik.touched.membershipfee && Formik.errors.membershipfee ? (
															<div className="text-danger">{Formik.errors.membershipfee}</div>
														) : null}
													</>
												)}
											</div>
										</div>
									</div>

									<div className="modal-footer">
										<button
											className="btn btn-labeled btn-success"
											type="submit"
											onClick={Formik.handleSubmit}
										>
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Create'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditSansthaId(null)
												Formik.resetForm()
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
export default MembershipPaymentdetailsTab
